import { render, staticRenderFns } from "./customize-form.vue?vue&type=template&id=2ac025c9&scoped=true"
import script from "./customize-form.vue?vue&type=script&lang=js"
export * from "./customize-form.vue?vue&type=script&lang=js"
import style0 from "./customize-form.vue?vue&type=style&index=0&id=2ac025c9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac025c9",
  null
  
)

export default component.exports